









import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({
  name: 'product-list-size-select'
})

export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;

  private pageSizes: number[] = [12, 24, 32, 48, 64];

  private get pageSize(): number {
    return Number(this.$store.getters[`${this.dataSource}/pageSize`]);
  }

  private updatePageSize(e): void {
    this.$store.dispatch(`${this.dataSource}/updatePageSize`, e.target.value);
  }
}
